/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// State
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// Datatable offsets
import { tableSchemaBase as columns } from '../offsets.columns';
import { tableSchemaBase as columnsWithoutBrand } from '../offsetsWithoutBrand.columns';
import { tableSchemaBase as columnsWithoutMonetization } from '../offsetsWithoutMonetization.columns';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IOffsetsDatatableSlice {
	offsetsDatatableOptions: any[];
	setOffsetsDatatableOptions: (
		_offsetsDatatableOptions: any[]
	) => void;
	offsetsDatatableWithoutBrandOptions: any[];
	setOffsetsDatatableWithoutBrandOptions: (
		_offsetsDatatableOptions: any[]
	) => void;
	offsetsDatatableWithoutMonetizationOptions: any[];
	setOffsetsDatatableWithoutMonetizationOptions: (
		_offsetsDatatableOptions: any[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeOffsetsDatatableSlice = (
	s: any
): any => ({
	offsetsDatatableOptions: s.offsetsDatatableOptions,
});

const initialState = {
	offsetsDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
	offsetsDatatableWithoutBrandOptions:
		columnsWithoutBrand.filter(
			(item) => item.defaultVisible
		),
	offsetsDatatableWithoutMonetizationOptions:
		columnsWithoutMonetization.filter(
			(item) => item.defaultVisible
		),
};

export const createOffsetsDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', any]],
	[],
	IOffsetsDatatableSlice
> = (set) => ({
	...initialState,
	setOffsetsDatatableOptions: (
		_offsetsDatatableOptions: any[]
	) =>
		set({
			offsetsDatatableOptions: _offsetsDatatableOptions,
		}),
	setOffsetsDatatableWithoutBrandOptions: (
		_offsetsDatatableOptions: any[]
	) =>
		set({
			offsetsDatatableWithoutBrandOptions:
				_offsetsDatatableOptions,
		}),
	setOffsetsDatatableWithoutMonetizationOptions: (
		_offsetsDatatableOptions: any[]
	) =>
		set({
			offsetsDatatableWithoutMonetizationOptions:
				_offsetsDatatableOptions,
		}),
});
